import React, { useEffect } from "react";
import iconbig from "../../assets/img/iconbig.png";
import iconcase from "../../assets/img/iconcase.png";
import "../../pages/index.css";
import { MdDone } from "react-icons/md";
import StickyForm from "./StickyForm";

const Timeline = () => {
  useEffect(() => {
    const handleScroll = () => {
      const container = document.querySelector(".coloringline");
      const icons = document.querySelectorAll(".righticon2, .righticon-small2");
      const scrollPosition = window.scrollY + window.innerHeight / 2; // Center of the viewport

      const containerTop =
        container.getBoundingClientRect().top + window.scrollY;
      const containerHeight = container.clientHeight;

      let progress = (scrollPosition - containerTop) / containerHeight;
      progress = Math.min(progress, 1);

      // Set the height of the before element
      container.style.setProperty("--before-height", `${progress * 100}%`);

      const fillHeight = containerHeight * progress;

      icons.forEach((icon, index) => {
        const iconRect = icon.getBoundingClientRect();
        const iconTop = iconRect.top + window.scrollY - containerTop;
        const iconBottom = iconTop + iconRect.height;

        // Adjust the condition to ensure the last icon gets colored
        if (
          fillHeight >= iconTop ||
          (index === icons.length - 1 && fillHeight >= iconBottom)
        ) {
          icon.classList.add("icon-colored");
        } else {
          icon.classList.remove("icon-colored");
        }
      });
    };

    window.addEventListener("scroll", handleScroll);

    // Clean up the event listener on component unmount
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="ps-lg-5 pt-8  coloringline lg:pr-[33%] pr-[10%] pl-[4%]" id="dynamic-content">
      <p class="py-4" >
        Lohia Group, a renowned machinery manufacturer, faced challenges with
        quote generation, impacting conversion rates and customer experience. By
        implementing Salesforce CRM, they streamlined workflows and integrated
        quote generation and customer inquiries into a unified system, boosting
        efficiency and client satisfaction.
      </p>
      <div className="row p-lg-0">
        <div className="col-lg-7 p-0">
          <p className="fw-normal mt-lg-5 mb-0 d-lg-block hidden text-justify">
            Lohia Group, a renowned machinery manufacturer, faced challenges
            with quote generation, impacting conversion rates and customer
            experience. By implementing Salesforce CRM, they streamlined
            workflows and integrated quote generation and customer inquiries
            into a unified system, boosting efficiency and client satisfaction.
          </p>
          <h3 className="mt-lg-5 righticon position-relative pt-3 text-3xl font-semibold">
            <div className="righticon2 ">
              {/* <img src={iconbig} alt="Icon" /> */}
              <MdDone />  
            </div>
            The <span className="text-[#00A1E0]">Challenges</span>
          </h3>
          <h5 className="righticon-small position-relative error text-[#0D4282] font-semibold text-2xl">
            <div className="righticon-small2  ">
              {/* <img src={iconcase} alt="Icon" /> */}
              <MdDone />
            </div>
            Quote shared with customer
          </h5>
          <p className="fw-normal mt-2 text-justify">
            The pricing for the standard machine available is shared via emails
            to the customers. For the technical description (Text BOM) and other
            important details, this quote was created in Microsoft Word by
            referencing earlier quotes.
          </p>
          <h5 className="righticon-small position-relative error text-[#0D4282] font-semibold text-2xl">
            <div  className="righticon-small2 ">
              {/* <img src={iconcase} alt="Icon" /> */}
              <MdDone />
            </div>
            Revised Quotes generation
          </h5>
          <p className="fw-normal mt-2 text-justify">
            The backed team provides a revised quote after a few days, but the
            customer frequently alters the requirements, making the tedious
            process repeat several times. Legal Compliance – Several months of
            delay in Customer acceptance of Quote
          </p>
          <h3 className="my-5 righticon position-relative pt-3  text-3xl font-semibold">
            <div className="righticon2">
              {/* <img src={iconbig} alt="Icon" /> */}
              <MdDone />
            </div>
            The <span className="text-[#00A1E0]">Solution</span>
          </h3>
          <h5 className="righticon-small position-relative error text-[#0D4282] font-semibold text-2xl">
            <div  className="righticon-small2 ">
              {/* <img src={iconcase} alt="Icon" /> */}
              <MdDone />
            </div>
            Instant Quote Generation with Dynamic Picklist Options and Signature
          </h5>
          <p className="fw-normal mt-2 text-justify">
            Quick customization options using a combination of interdependent
            picklist/dropdown options. On a single click, quote generation in
            PDF/Word format with signature based on frequently changing customer
            requirements.
          </p>
          <h5 className="righticon-small position-relative error text-[#0D4282] font-semibold text-2xl">
            <div  className="righticon-small2 ">
              {/* <img src={iconcase} alt="Icon" /> */}
              <MdDone />
            </div>
            Commercial and Technical Quotes Creation
          </h5>
          <p className="fw-normal mt-2 text-justify">
            On the fly, multiple commercial [price calculations] & technical
            quotes [Text BOM] can be generated. Multi-line editor used to
            quickly select different categories & configurations of machines.
          </p>
          <h5 className="righticon-small position-relative error text-[#0D4282] font-semibold text-2xl">
            <div  className="righticon-small2">
              {/* <img src={iconcase} alt="Icon" /> */}
              <MdDone />
            </div>
            Eliminating Price Alterations for Custom Machinery
          </h5>
          <p className="fw-normal mt-2 text-justify">
            Precise pricing solutions were provided, eliminating adjustments
            based on customized machine specifications, ensuring transparency
            and reliability, and providing them with fixed costs for their
            customized equipment.
          </p>
          <h5 className="righticon-small position-relative error text-[#0D4282] font-semibold text-2xl">
            <div  className="righticon-small2 ">
              {/* <img src={iconcase} alt="Icon" /> */}
              <MdDone />
            </div>
            Real-Time Revisions and Seamless eSign Integration
          </h5>
          <p className="fw-normal mt-2 text-justify">
            They provided an innovative quoting platform for swift adjustments
            and real-time quote revisions. The seamless integration of
            DocuSign's eSign feature streamlined customer responses, enhancing
            the quoting process.
          </p>

          <div className="bg-[#EAF5FE] p-3 ps-4 pe-5 my-5 ">
            <div className="lg:flex lg:flex-row error items-center">
              <div className="text-[50px] font-extrabold text-[#0D4282] ">45%</div>
              <h5 className="mt-2 ms-3 text-2xl font-semibold">
                Leads got lost and customer faced issue in getting a proper
                quote.
              </h5>
            </div>
          </div>
          <h3 className="my-5 righticon position-relative pt-3  text-3xl font-semibold">
            <div className="righticon2">
              {/* <img src={iconbig} alt="Icon" /> */}
              <MdDone />
            </div>
            The <span className="text-[#00A1E0]">Benefit</span>
          </h3>
          <h5 className="righticon-small position-relative error text-[#0D4282] font-semibold text-2xl ">
            <div className="righticon-small2 ">
              {/* <img src={iconcase} alt="Icon" /> */}
              <MdDone />
            </div>
            Fast Responses
          </h5>
          <p className="fw-normal mt-2 text-justify">
            Solution ensures minimal Turnaround Time (TAT) with immediate
            responses to customers, while also reducing the workload for sales
            teams, eventually improving performance and efficiency in sales.
          </p>
          <h5 className="righticon-small position-relative error text-[#0D4282] font-semibold text-2xl">
            <div  className="righticon-small2">
              {/* <img src={iconcase} alt="Icon" /> */}
              <MdDone />
            </div>
            Instant Quotes Comparison
          </h5>
          <p className="fw-normal mt-2 text-justify">
            By providing customers with the ability to compare quotes instantly,
            the solution enhances clarity on offerings, leading to informed
            decisions and higher probabilities of opportunity conversion.
          </p>
          <h5 className="righticon-small position-relative error text-[#0D4282] font-semibold text-2xl">
            <div  className="righticon-small2 ">
              {/* <img src={iconcase} alt="Icon" /> */}
              <MdDone />
            </div>
            Saving Manpower
          </h5>
          <p className="fw-normal mt-2 text-justify">
            The efficiency optimization solution ensures manpower conservation
            and eliminates the need for multiple follow-ups and information loss
            across departments, resulting in smoother operations and increased
            productivity.
          </p>
          <h5 className="righticon-small position-relative error text-[#0D4282] font-semibold text-2xl">
            <div  className="righticon-small2 ">
              <MdDone />
              {/* <img src={iconcase} alt="Icon" /> */}
            </div>
            Efficient Legal Compliance
          </h5>
          <div className="d-lg-none d-block" id="normal-id">
            <p className="fw-normal text-justify">
              Customers can conveniently sign documents using the DocuSign
              feature, ensuring legal compliance without any hassle.
            </p>
            <div className="bg-[#EAF5FE] px-3 my-5">
              <div className="error lg:flex lg:flex-row error items-center py-3">
                <div className="text-[50px]  text-[#0D4282] font-extrabold">95%</div>
                <h5 className="text-2xl font-semibold p-2">
                  Leads got lost and customer faced issue in getting a proper
                  quote.
                </h5>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="d-lg-block hidden">
        <p className="fw-normal mt-2 col-7 text-justify ml-[135px]">
          Customers can conveniently sign documents using the DocuSign feature,
          ensuring legal compliance without any hassle.
        </p>
        <div className="d-lg-block hidden">
          <div className="error px-4 mt-5">
            <div className="d-lg-flex error">
              <div className="text-[50px] text-[#0D4282] font-extrabold">95%</div>
              <h5 className="mt-2 ms-3">
                Leads got lost and customer faced issue in getting a proper
                quote.
              </h5>
            </div>
          </div>
        </div>
      </div>

      
            <StickyForm />
    </div>
  );
};

export default Timeline;
